module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"title":"Informações básicas","description":"Vamos começar! É bem simples, primeiro precisamos dos seus dados básicos: nome, e-mail e celular.","rd":"Entrar com RD Station","back":"Voltar","next":"Próximo","finish":"Finalizar","registered":"Já possuo cadastro.","login":"Quero entrar.","busy":"Cadastrando...","ready":{"title":"Cadastro completado com sucesso!","description":"Você já pode fazer o Login na sua conta do RD SMS!","login":"Ir para tela de Login"}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Auth/Register.vue
// module id = 147
// module chunks = 0